export default __webpack_public_path__ + "static/media/how-it-works-1.81146f9c.png";